import { Check, RefreshCw, Shield, User } from "lucide-react";

export const LongArrow = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 34 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1 6h30M26.5 1.5 31 6l-4.5 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShieldCheckStack = ({ size = "2rem", strokeWidth = 1.4 }) => (
  <span className="icon-stack" style={{ width: size, height: size }}>
    <Shield className="icon-base" strokeWidth={strokeWidth} />
    <Check className="icon-accent icon-accent-center" strokeWidth={2.6} />
  </span>
);

export const UserCheckStack = ({ size = "2.5rem" }) => (
  <span className="icon-stack" style={{ width: size, height: size }}>
    <User className="icon-base" strokeWidth={1.4} />
    <Check className="icon-accent icon-accent-corner" strokeWidth={2.6} />
  </span>
);

export const RefreshCheckStack = ({ size = "2.5rem" }) => (
  <span className="icon-stack" style={{ width: size, height: size }}>
    <RefreshCw className="icon-base" strokeWidth={1.4} />
    <Check className="icon-accent icon-accent-corner" strokeWidth={2.6} />
  </span>
);

export const ExpandBox = ({ size = "1.5rem", className }) => (
  <svg
    className={className}
    style={className ? undefined : { width: size, height: size }}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect x="3" y="3" width="18" height="18" rx="1.5" />
    <path d="M13.5 10.5 17 7M17 7h-3.2M17 7v3.2" />
    <path d="M10.5 13.5 7 17M7 17h3.2M7 17v-3.2" />
  </svg>
);

export const TargetDot = () => (
  <svg
    className="row-dot"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="6" cy="6" r="4.6" stroke="#85a125" strokeWidth="1.1" />
    <circle cx="6" cy="6" r="1.5" fill="#85a125" />
  </svg>
);

